import { render, staticRenderFns } from "./500ServerError.vue?vue&type=template&id=78b1b0f7&scoped=true"
var script = {}
import style0 from "./500ServerError.vue?vue&type=style&index=0&id=78b1b0f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1b0f7",
  null
  
)

export default component.exports